import React, { useEffect, useState } from 'react'
import Layout from '../../Layout/Layout'
import ShopPageSection1 from './ShopPageSection1.js'
import Footer from '../../Layout/Footer'
import ShopServices from './ShopServices.js'
import ShopAPI from './ShopAPI.js'
import ShopAPI1 from './ShopAPI1.js'
import FooterCalendar from '../../Layout/FooterCalendar.js'
import ShopAPI2 from './ShopAPI2.js'
import FooterNew from '../../Layout/FooterNew.js'
import SEO from '../../SEO.js'
import axios from 'axios'
const BASE_URL = "https://ecom.cyberathon.com/index.php/Api"; 
function ShopPage() {
  const [seoData, setSeoData] = useState({});
useEffect(() => {
  const fetchSeo = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/get_seo_by_page`, { page_name: 'shop' });

      if (response.data.status === 'true') {
        const data = response.data.data;
        setSeoData({
          title: data.meta_title,
          description: data.meta_description,
          keywords: data.meta_keywords,
          canonical: data.canonical_url,
        });
      }
    } catch (error) {
      console.error('SEO fetch error:', error);
    }
  };

  fetchSeo();
}, []);
  return (
   <>
   <SEO
    title={seoData.title || "best cupping therapy tools ,authentic cupping supplies | shopeindia"}
    description={seoData.description || "ShopIndia is the best online shopping platform..."}
    keywords={seoData.keywords || "ShopIndia, online shopping, electronics, clothes, medicines"}
    canonical={seoData.canonical || "https://www.shopindia.com/"}
  />
   <Layout/>
   {/* <ShopPageSection1/> */}
   {/* <ShopServices/> */}
   {/* <ShopAPI/> */}
   {/* <ShopAPI1/> */}
   <ShopAPI2/>
   {/* <Footer/> */}
   {/* <FooterCalendar/> */}
   <FooterNew/>
   </>
  )
}

export default ShopPage;
